<template>
  <div class="flex flex-wrap justify-between items-center gap-2 mt-2">
    <!-- <span class="flex-1 min-w-[200px]">
      <MultiSelect 
        :selectedItemsLabel="`{0} ${selectionLabel} selected`" 
        v-model="selectedSitesValue"
        :options="sites" 
        optionLabel="siteName" 
        filter 
        placeholder="Select Sites"
        :maxSelectedLabels="2" 
        class="w-full"
        @update:modelValue="$emit('update:selectedSites', $event)"
      />
    </span>
    <span class="flex-1 min-w-[200px] py-2 lg:py-0">
      <MultiSelect 
        selectedItemsLabel="{0} advertisers selected" 
        v-model="selectedAdvertisersValue"
        :options="distinctAdvertisers" 
        optionLabel="advertiserName" 
        optionValue="advertiserId"
        filter 
        placeholder="Select advertisers" 
        :maxSelectedLabels="2" 
        class="w-full"
        @update:modelValue="$emit('update:selectedAdvertisers', $event)"
      />
    </span>
    <span class="flex-1 min-w-[180px] py-2 lg:py-0">
      <SelectButton 
        class="primevue-multiselect-border text-white rounded-md w-full"
        v-model="chartTypeValue" 
        :options="chartTypes" 
        optionLabel="label" 
        optionValue="value"
        aria-labelledby="basic" 
        @update:modelValue="$emit('update:chartType', $event)"
      />
    </span> -->
    <span class="flex-1 min-w-[200px]">
      <DatePicker 
        v-model="datesValue" 
        selectionMode="range" 
        showIcon 
        :showOnFocus="true"
        class="w-full py-2 sm:py-0"
        @update:modelValue="$emit('update:dates', $event)"
      />
    </span>
    <span class="flex-1 min-w-[180px]">
      <Select 
        v-model="selectedDatePresetValue" 
        :options="datePresets" 
        optionLabel="name"
        class="w-full"
        @change="handleDatePresetChange"
      />
    </span>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  selectedSites: {
    type: Array,
    required: true
  },
  selectedAdvertisers: {
    type: Array,
    required: true
  },
  chartType: {
    type: String,
    required: true
  },
  dates: {
    type: Array,
    required: true
  },
  selectedDatePreset: {
    type: Object,
    required: true
  },
  sites: {
    type: Array,
    required: true
  },
  distinctAdvertisers: {
    type: Array,
    required: true
  },
  chartTypes: {
    type: Array,
    required: true
  },
  datePresets: {
    type: Array,
    required: true
  },
  selectionLabel: {
    type: String,
    required: true
  }
});

const emit = defineEmits([
  'update:selectedSites',
  'update:selectedAdvertisers',
  'update:chartType',
  'update:dates',
  'update:selectedDatePreset',
  'datePresetChange'
]);

// Use computed properties for v-model
const selectedSitesValue = computed({
  get: () => props.selectedSites,
  set: (value) => emit('update:selectedSites', value)
});

const selectedAdvertisersValue = computed({
  get: () => props.selectedAdvertisers,
  set: (value) => emit('update:selectedAdvertisers', value)
});

const chartTypeValue = computed({
  get: () => props.chartType,
  set: (value) => emit('update:chartType', value)
});

const datesValue = computed({
  get: () => props.dates,
  set: (value) => emit('update:dates', value)
});

const selectedDatePresetValue = computed({
  get: () => props.selectedDatePreset,
  set: (value) => emit('update:selectedDatePreset', value)
});

const handleDatePresetChange = (event) => {
  emit('datePresetChange', event);
};
</script> 

<style scoped>

</style>